<script lang="ts">
  import { onMount } from "svelte";
  import { addMonths, format, subDays } from "date-fns";
  import Stack from "../../components/Stack.svelte";
  import Text from "../../components/Text.svelte";
  import TextNew from "../../components/TextNew.svelte";
  import LargeButton from "../../components/buttons/LargeButton.svelte";
  import CheckmarkGreen from "../../components/icons/CheckmarkGreen.svelte";
  import TrialSteps from "./TrialSteps.svelte";
  import ProductCard from "./ProductCard.svelte";

  const DEFAULT_PRICE = "£100";

  export let loading: boolean;
  export let onContinue: () => void;
  let currentDate = new Date();
  let reminderDate: Date = new Date();
  let paidStartDate: Date = new Date();

  onMount(() => {
    paidStartDate = addMonths(currentDate, 1);
    reminderDate = subDays(paidStartDate, 7);
  });
</script>

<div class="container">
  <div class="left">
    <Text size="large" bold>get your first 30 days of Premium for free</Text>
    <div class="content">
      <div class="bullets">
        <div class="bullet">
          <div class="bullet-icon">
            <CheckmarkGreen />
          </div>
          <Text size="xs" color="dark">first 30 days free, cancel at any time</Text>
        </div>
        <div class="bullet">
          <div class="bullet-icon">
            <CheckmarkGreen />
          </div>
          <Text size="xs" color="dark">we'll remind you before your free 30 days ends</Text>
        </div>
      </div>

      <ProductCard subtitle={"first 30 days free"} additional={`${DEFAULT_PRICE}/month +VAT`} />
    </div>
    <div class="footer">
      <div class="totals">
        <Stack horizontal justifyContent="space-between">
          <TextNew size="xs" weight="medium">total due today</TextNew>
          <TextNew size="xs" weight="medium">£0.00</TextNew>
        </Stack>
        <Stack horizontal justifyContent="space-between">
          <TextNew size="xs" --rk-text-color="var(--rk-text-transparency-dark)"
            >{`starting on ${format(paidStartDate, "d MMM, yyyy")}`}</TextNew
          >
          <TextNew size="xs" --rk-text-color="var(--rk-text-transparency-dark)"
            >{`${DEFAULT_PRICE}/month +VAT`}</TextNew
          >
        </Stack>
      </div>

      <LargeButton title="get 30 days free" onClick={onContinue} {loading} />
      <div class="info">
        <TextNew size="xxs" --rk-text-color="var(--rk-text-transparency-dark)">
          REKKI Insights <a
            href="https://tandc.rekki.com/REKKI%20BUYER%20Saas%20Terms.pdf"
            target="_blank">terms</a
          > apply
        </TextNew>
      </div>
    </div>
  </div>
  <div class="right">
    <TrialSteps {reminderDate} {paidStartDate} />
  </div>
</div>

<style>
  .container {
    display: flex;
    flex: 1;
  }
  .left,
  .right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    box-sizing: border-box;
    width: 50%;
  }

  .left {
    padding: 32px 24px 24px 24px;
  }

  .right {
    background-color: var(--rekki-neutral-01);
    justify-content: center;
    align-items: center;
  }
  .content {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    width: 100%;
  }

  .bullets {
    margin-top: 16px;
    margin-bottom: 32px;
  }

  .bullet {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    /* margin-bottom: 20px; */
  }

  .bullet-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 4px;
  }

  .info {
    display: flex;
    flex-direction: row;
    margin-top: 16px;
    color: var(--rekki-transparency-dark);
  }

  a {
    color: var(--rekki-transparency-dark);
  }
  .totals {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 16px;
  }

  .footer {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: 100%;
  }
</style>
